import { GzEnumFilterWebComponent } from '../../../../ui/gzEnumFilter';
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { GzTagsEnumListWebComponent } from '../../gzTagsEnumList';
import { ifDefined } from 'lit/directives/if-defined.js';

export class GzTagsEnumFilterWebComponent extends GzEnumFilterWebComponent {
  @property({ type: String, attribute: true, reflect: true })
  allAutoTagsLabel = '';

  @property({ type: String, attribute: true, reflect: true })
  allCustomTagsLabel = '';

  @property({ type: String, attribute: true, reflect: true })
  emptyFilterString;

  @query('#multiple-selection-list')
  protected readonly enumList!: GzTagsEnumListWebComponent;

  /**
   * Overwritten
   * @returns {TemplateResult}
   * @protected
   */
  protected renderEnumList() {
    return html`<gz-tags-enum-list
      id="multiple-selection-list"
      .filterOptions="${this.filterOptions}"
      searchPlaceholderString="${this.searchPlaceholderString}"
      noSearchResultsString="${this.noSearchResultsString}"
      noResultsInDefaultGroup="${ifDefined(this.noResultsInDefaultGroup)}"
      listTitle="${this.listTitle}"
      .canSelectAll="${this.canSelectAll}"
      allAutoTagsLabel="${this.allAutoTagsLabel}"
      allCustomTagsLabel="${this.allCustomTagsLabel}"
      @optionChanged="${this.handleListOptionsChange}"
      label="${this.label}"
      labelWidth="${this.labelWidth}"
      placeholder="${this.placeholder}"
      class="enum-filter-list"
      .searchMaxLength="${ifDefined(this.searchMaxLength)}"
      .emptyFilterString="${ifDefined(this.emptyFilterString)}"
    ></gz-tags-enum-list>`;
  }
}
